import React, { useState } from "react";
import { mdiMenuDown } from "@mdi/js";
import Icon from "@mdi/react";

export default function DropDown({ placeholder, content, dropdownHandler }) {
  const [active, setActive] = useState(0);
  const [value, setValue] = useState(0);
  const _handle = (item, key) => {
    setValue(item);
    setActive(0);
    dropdownHandler(value);
  };
  return (
    <div className={active ? "dropdown_wrapper active" : "dropdown_wrapper"}>
      <span
        onClick={() => {
          setActive(active ? 0 : 1);
        }}
      >
        {value ? value : placeholder} <Icon path={mdiMenuDown} />
      </span>
      <div className="drop_down">
        <ul>
          {content &&
            content.map((item, key) => {
              return (
                <li onClick={_handle(item, key)} key={key}>
                  {item}
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}
